import React from 'react';
import { useEffect } from 'react';

import { Box, Paper, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import LeaveCreateForm from './LeaveCreateForm';
import LeaveRequestDialog from './LeaveRequestDialog';
import MyLeaveRequests from './MyLeaveRequests';
import YearCalendar from './YearCalendar';
import api from '../../services/api';
import '../TopBar.css';


export default function LeavePage() {
  const [refreshKey, setRefreshKey] = React.useState(0);
  const [draft, setDraft] = React.useState({ leaveTypeId:'', startDate:'', days:'' });
  const [dlg, setDlg] = React.useState({ open:false, title:'', message:'' });
  const [rqOpen, setRqOpen] = React.useState(false);
  const [summary, setSummary] = React.useState({ available: null, projected: null });

  const refreshAll = () => setRefreshKey(k => k + 1);

  React.useEffect(() => {
    const handler = (ev) => {
      const { startYmd, endYmd, days } = ev.detail || {};
      if (startYmd && days) {
        setDraft(d => ({ ...d, startDate: startYmd, days: String(days) }));
        // Без ремоунт при селекция от календара
      }
    };
    window.addEventListener('hrapp.calendar.range', handler);
    return () => window.removeEventListener('hrapp.calendar.range', handler);
  }, []);

  React.useEffect(() => {
    const openDlg = (ev) => {
      const { startYmd, days } = ev.detail || {};
      if (startYmd && days) {
        setDraft(d => ({ ...d, startDate: startYmd, days: String(days) }));
        setRqOpen(true);
      }
    };
    window.addEventListener('hrapp.open.request.dialog', openDlg);
    return () => window.removeEventListener('hrapp.open.request.dialog', openDlg);
  }, []);

  React.useEffect(() => {
    const onDialog = (ev) => {
      const { title, message } = ev.detail || {};
      setDlg({ open:true, title: title || 'Message', message: message || '' });
    };
    window.addEventListener('hrapp.dialog', onDialog);
    return () => window.removeEventListener('hrapp.dialog', onDialog);
  }, []);

  // Load summary indicator (Available, Projected) from balances and requests
  React.useEffect(() => {
    (async () => {
      try {
        const [bals, reqs] = await Promise.all([
          api.get('/leave-balances/mine'),
          api.get('/leave-requests/mine')
        ]);
        const y = new Date().getFullYear();
        const al = (Array.isArray(bals)?bals:[]).find(b => String(b.code||b.Code||'').toUpperCase()==='AL' && Number(b.year||b.Year)===y);
        const available = al ? Number(al.remainingDays || al.RemainingDays || 0) : null;
        const pendingSum = (Array.isArray(reqs)?reqs:[])
          .filter(r => ['Pending','PendingDM','PendingBoard'].includes(String(r.status||r.Status)))
          .filter(r => (new Date(r.startDate||r.StartDate)).getFullYear()===y)
          .reduce((acc,r)=> acc + Number(r.businessDays||r.BusinessDays||0), 0);
        const projected = (available==null) ? null : Math.max(0, available - pendingSum);
        const summary = { available, projected };
        setSummary(summary);
        if (typeof window !== 'undefined') window.__leaveSummary = summary;
      } catch {
        setSummary({ available: null, projected: null });
      }
    })();
  }, [refreshKey]);

  // Global events from TopBar
  React.useEffect(() => {
    const openNew = () => setRqOpen(true);
    const doRefresh = () => { setDraft({ leaveTypeId:'', startDate:'', days:'' }); refreshAll(); };
    window.addEventListener('hrapp.open.new.request', openNew);
    window.addEventListener('hrapp.leave.refresh', doRefresh);
    return () => {
      window.removeEventListener('hrapp.open.new.request', openNew);
      window.removeEventListener('hrapp.leave.refresh', doRefresh);
    };
  }, []);

  return (
    <>
      <Dialog open={dlg.open} onClose={() => setDlg({ ...dlg, open:false })}>
        <DialogTitle>{dlg.title}</DialogTitle>
        <DialogContent>{dlg.message}</DialogContent>
        <DialogActions>
          <Button onClick={() => setDlg({ ...dlg, open:false })} autoFocus>OK</Button>
        </DialogActions>
      </Dialog>

      <Box sx={{ p: 2, display:'grid', gridTemplateColumns:'1fr 1fr', gap:2 }}>
        <Paper sx={{ p: 2, gridColumn:'1 / -1' }}>
          <MyLeaveRequests key={refreshKey} />
        </Paper>
        <LeaveRequestDialog
          open={rqOpen}
          onClose={()=>{ setRqOpen(false); setDraft(d=>({ ...d, startDate:'', days:'' })); }}
          draft={draft}
          onDraftChange={setDraft}
          onCreated={refreshAll}
          onRefresh={refreshAll}
        />
        <Paper sx={{ p: 2, gridColumn:'1 / -1' }}>
          <YearCalendar key={refreshKey} draft={draft} />
        </Paper>
      </Box>
    </>
  );
}

